import { Injectable } from '@angular/core';
import { Http, Response} from "@angular/http";
import { config } from "../../../config/str";
import { sha256 } from "sha256"
import { Observable} from "rxjs/Observable";
import { PayeeCustomer } from "../../model/payee_customer";
import { Invoice} from "../../model/invoice";
import { AngularFireDatabase} from "angularfire2/database";
import { StripeSubs} from "../../model/stripe-subs";
import { Subject} from "rxjs/Subject";



@Injectable()
export class LocalStripeService {
  private sdkDb: firebase.database.Reference;

  private accountingURL:string = config.StripeService;
  private data: any = {};

  constructor(
    private http: Http,
    private db:AngularFireDatabase
    ) {
    this.sdkDb = db.app.database().ref();
  }




  getInvoicesByKey(restaurantKey:string):Observable<Invoice[]>{
     // console.log(restaurantKey);
    const invoices = this.db.list('invoices/'+restaurantKey)
      // .do(result => console.log(result))
      .map (Invoice.fromJsonList)

     // console.log(invoices);
    return invoices;

  }

  getStripeCustomer(restaurantKey:string):Observable<any>{

    const customer = this.db.list('stripe_customers',{
      query:{
        orderByChild:'restaurant_id',
        equalTo:restaurantKey
      }
    })
      // .do(result => console.log(result));
      .filter( result => result && result.length > 0)
      .map(result => PayeeCustomer.fromJson(result[0]))
      .first();

    return customer;
  }

  getStripeCustomerByKey(customerId:string):Observable<any>{

    const customer = this.db.list('stripe_customers',{
      query:
        {
        orderByKey:true,
        equalTo:customerId
        }
      })
      // .do(result => console.log(result))
      .filter( result => result && result.length > 0)
      .map(result => PayeeCustomer.fromJson(result[0]))
      .first();

    return customer;
  }


  getBillingInfo(restaurantKey:any) :Observable<PayeeCustomer>{

     // console.log("Getting Billing Info!" + restaurantKey);

    const customer$ = this.db.list('stripe_customers',{
      query:{
        orderByChild:'restaurant_id',
        equalTo:restaurantKey
      }
    })
     // .do(result => console.log(result))
     .filter( result => result && result.length > 0)
      .map(result => PayeeCustomer.fromJson(result[0]));
    // .first()

    return customer$;

  }


  getUpcomingInvoice(customerKey:string):Observable<any>{
    // console.log("Upcoming Invoice");
    const invoice = this.db.list('upcoming_invoices/'+customerKey)
      // .do(result => console.log(result))
      .filter( result => result && result.length > 0)
      .map(result => Invoice.fromJson(result[0]));

    return invoice;
  }

  getSubscription(id: string):Observable<any> {
    let path = 'subscriptions/'+id;
    // console.log(path);

    const sub$ = this.db.list(path)
      .map(result => StripeSubs.fromJson(result[0]))
    return sub$;
  }

  getSources(customerKey:string):Observable<any>{

    const sources = this.http.get(this.accountingURL+'listsources/'+customerKey)
      // .do(result => console.log(result))
      .map((res:Response)=>res.json())
      // .map(res=>Source.fromJson(res[0]))
      .catch((error:any)=>Observable.throw(error || 'Server Error'));

    return sources;

  }

  getInvoiceByKey(customerid: any, invoiceid: any):Observable<Invoice>{
    // console.log("id :"+customerid+" inv :"+invoiceid);

    const invoice$ = this.db.list('invoices/'+customerid , {
      query:{
        orderByKey:true,
        equalTo:invoiceid
      }
    })
      .map(result => Invoice.fromJson(result[0]));

    return invoice$;

  }


  addSourcetoCustomer(cusrtomerId:string,sourceId:string):Observable<any>{

    let customerSource = Object.assign({},{"customerid":cusrtomerId,"sourceid":sourceId});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/addsource/"] = customerSource;

    return this.firebaseUpdate(dataToSave);
  }


  updateCustomerSource(customerid: string, sourceid: string, oldSourceid:string):Observable<any> {


    let customerSource = Object.assign({},{"customerid":customerid,"sourceid":sourceid,"oldsourceid":oldSourceid});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/updatesource/"] = customerSource;

    // console.log("Showing Customer Source for CC Edit");
    // console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);

  }

  updateCustomerEmail(customerid: string, email: string):Observable<any> {


    let customerSource = Object.assign({},{"customerid":customerid,"email":email});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/updateemail/"] = customerSource;

    // console.log("Showing Customer  for Email Edit");
    // console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);

  }

  cancelCustomerSubscription(subscriptionid: string):Observable<any> {

    // console.log(subscriptionid);


    let subscription = Object.assign({},{"subscriptionid":subscriptionid});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/cancelsubscription/"] = subscription;

    // console.log("Cancel subscription");
    // console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);

  }


  restoreCustomerSubscription(subscriptionid: string) {

    // console.log(subscriptionid);


    let subscription = Object.assign({},{"subscriptionid":subscriptionid});

    let dataToSave = {};

    dataToSave["queue/tasks/acction/accounting/restoresubscription/"] = subscription;

    // console.log("Restore subscription");
    // console.log(dataToSave);

    return this.firebaseUpdate(dataToSave);



  }

  private firebaseUpdate(dataToSave: {}) {

    const subject = new Subject();

    this.sdkDb.update(dataToSave)
      .then(
        val =>{

          subject.next(val);
          subject.complete();

        },
        err =>{

          subject.error(err);
          subject.complete();

        }
      );

    return subject.asObservable();
  }



}



/*


  public getdata(){

    return this.http.get(this.accountingURL)
      .map((res :  Response) => res.json())

  }

  getCards(customerKey:string):Observable<any>{

    const cards = this.http.get(this.accountingURL+'listcards/'+customerKey)
      .map((res:Response)=>res.json())
      .catch((error:any)=>Observable.throw(error.json().erroe || 'Server Error'));

    return cards;

  }

  getInvoice(invoice_id:string):Observable<any>{

    const invoice = this.http.get(this.accountingURL+'invoice/'+invoice_id)
      .map((res:Response)=>res.json())
      .catch((error:any)=>Observable.throw(error.json().erroe || 'Server Error'));

    return invoice;

  }


  testApi(){

    this.getdata().subscribe( data => {

      console.log(this.accountingURL);
      console.log(sha256(config.secret));
      console.info(data);
      this.data = data;
      return this.data;

    })

  }

  getUpcomingInvoices(customer_id:string):Observable<any> {

    const invoices = this.http.get(this.accountingURL+'upcommingInvoices/'+customer_id)
      .map((res:Response) => res.json())
      .catch((error:any) => Observable.throw(error.json().error || 'Server error'));

    return invoices;

  }

  getPreviousInvoices(customer_id:string, dateParam:number):Observable<any> {

    const invoices = this.http.get(this.accountingURL+'previousInvoices/'+customer_id+'/'+dateParam)
      .map((res:Response) => res.json())
      .catch((error:any) => Observable.throw(error.json().error || 'Server error'));

    return invoices;

  }




 */



// WEBPACK FOOTER //
// ./src/app/shared/services/stripe/local.stripe.service.ts